import { Link } from '@tiptap/extension-link';
import { StarterKit } from '@tiptap/starter-kit';
import { TkMarker } from '@ws/shared/components';

const linkExt = Link.configure({
  openOnClick: true,
  autolink: true,
  linkOnPaste: true,
  defaultProtocol: 'https',
  protocols: ['http', 'https'],
  HTMLAttributes: {
    target: '_blank',
    rel: 'noopener noreferrer nofollow',
    class: 'prose-link',
  },
});

/**
 * Расширения, формирующие СХЕМУ заметки.
 *
 * Вынесено из компонента и экспортировано не для красоты: этот же массив
 * уходит в `generateHTML` при разрезании заметки, и узел, забытый здесь,
 * молча пропадает из отделённой половины. Экспорт даёт тесту возможность
 * проверить состав, а не полагаться на внимательность читающего.
 *
 * Расширения, не влияющие на схему (поведение клавиш, разделитель), сюда не
 * входят — они добавляются в сам редактор.
 */
export const extensions = [StarterKit, linkExt, TkMarker];
